import React from 'react';

const SignUpBanner = ({ onSignUpClick }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-red-500 to-pink-600 rounded-3xl p-8 lg:p-14 flex flex-col lg:flex-row items-center gap-8 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-48 translate-x-48"></div>

          <div className="flex-1 text-white relative z-10 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">Sign Up For Free</h2>
            <p className="text-white/80 text-lg mb-6">
              Get access to exclusive deals, bottom rates, and personalized property recommendations
            </p>
            <button
              onClick={onSignUpClick}
              className="bg-white text-red-500 hover:bg-gray-100 px-10 py-4 rounded-full font-bold text-lg transition shadow-lg"
            >
              Sign Up
            </button>
          </div>

          <div className="hidden lg:block relative z-10">
            <img
              src="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=400&q=80"
              alt="Happy Family"
              className="w-80 h-64 object-cover rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUpBanner;
